const contentTypes = [
  {
    type: "ARTICLE",
    text: "Artigo",
  },
  {
    type: "WEBSITE",
    text: "Website",
  },
  {
    type: "VIDEO",
    text: "Vídeo",
  },
  {
    type: "INSTAGRAM",
    text: "Instagram",
  },
  {
    type: "FACEBOOK",
    text: "Facebook",
  },
  {
    type: "Whatsapp",
    text: "Whatsapp",
  },
  {
    type: "Linkedin",
    text: "Linkedin",
  },
  {
    type: "Telegram",
    text: "Telegram",
  },
  {
    type: "Twitter",
    text: "Twitter",
  },
  {
    type: "LandingPage",
    text: "LandingPage",
  },
];
const campaignEnum = [
  {
    enum: "IMAGE",
    text: "Imagem",
  },
  {
    enum: "REDIRECT",
    text: "Redirecionamento",
  },
  {
    enum: "VIDEO",
    text: "Vídeo",
  },
  {
    enum: "REWARD",
    text: "Recompensa",
  },
];

export {campaignEnum, contentTypes}